import { exec, getApiToken } from '../utils';
import type {
  SearchStyleArgs,
  SearchStyleExecVariables,
  SearchStyleResponse,
  SearchStyleExecResponse
} from '@src/types';

export const searchStyle = async (
  search: SearchStyleArgs,
  token: string
): Promise<SearchStyleResponse> => {
  const apiToken = await getApiToken(token);

  const { filters, partnerCode, query, offset, limit } = search;

  const searchQuery = `
    query catalogManagementSearchShop(
      $partnerCode: String
      $token: String!
      $query: String!
      $filters: [FacetLimitPublic]
      $offset: Int
      $limit: Int
    ) {
      restUser(token: $token) {
        partner(code: $partnerCode) {
          catalogManagementSearchShop {
            search(
              query: $query
              filters: $filters
              offset: $offset
              limit: $limit
            ) {
              count
              queryId
              items {
                brand
                brandDisplay
                categories
                category
                checkin
                colorCode
                colorDisplay
                data
                department
                eligibility
                hexCode
                hexUrl
                imageUrls
                parentSKU
                msrpPrice
                title
                variantCount
              }
            }
          }
        }
      }
    }
  `;

  const data = await exec<SearchStyleExecVariables, SearchStyleExecResponse>(
    searchQuery, {
      variables: {
        token: apiToken,
        ...search,
        partnerCode,
        query,
        filters: filters ?? [],
        offset,
        limit,
      },
    },
  );
  return data.restUser.partner.catalogManagementSearchShop;
};
